// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d38ee489","453":"2a8c832b","455":"08f9ad08","977":"27f47829"}[chunkId] + ".chunk.js";
};